export const NOYO_EMPLOYEE_BASE_URL = 'https://app.noyo.com/employees'

export function noyoEmployeeUrl(noyoEmployeeId: string): string {
  return `${NOYO_EMPLOYEE_BASE_URL}/${noyoEmployeeId}`
}

export function employeeCoveragePath(employeePublicKey: string): string {
  return `/employees/${employeePublicKey}/coverage`
}
